<template>
	<div class="text-blocks-wrapper" :class="{'apply-ellipsis': applyEllipsis === true}">
		<!-- Label -->
		<label-generic v-if="params.label" :text="params.label"/>
		<!-- Content -->
		<a :href="`tel:${params.phoneNumber}`">
			<div class="content-wrapper with-button-icon">
				<!-- Content -->
				<div class="content" :class="{'apply-ellipsis': applyEllipsis === true}" v-mask="params.mask">
					{{params.phoneNumber}}
				</div>
				<!-- Solo Icon Button on Right -->
				<div class="right-icon-button" @click.stop="emit('rightButtonClicked')">
					<right-button-icon-component class="icon"/>
				</div>
			</div>
		</a>
	</div>
</template>

<script setup>
import LabelGeneric from '@/components/generic/labels/Generic'

/* Vue */
import { computed, defineAsyncComponent } from 'vue'

/** props received
@params { Object } with:
	- label { String}
	- phone { Number }
	- mask { Object }
@applyEllipsis {Boolean}
*/
const props = defineProps({
	params: Object,
	applyEllipsis: Boolean
})

/* Emmitters */
const emit = defineEmits(['rightButtonClicked'])

/* Computed */
const rightButtonIconComponent = computed(() => {
	return defineAsyncComponent(() => import('@/assets/icons/phone.svg?inline'))
})
</script>

<style lang="scss" scoped>
.text-blocks-wrapper {
	width: 100%;
    height: fit-content;

    &.apply-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .content-wrapper {
            .content {
                text-overflow: ellipsis;
            }
        }
    }
    .content-wrapper {
        width: fit-content;
        display: flex;
        gap: 4px;

        margin-top: 8px;
        position: relative;

        .right-icon-button {
            bottom: -4px;
            right: 0;

            position: absolute;
            cursor: pointer;

			svg {
                width: 20px;
                height: 20px;

                :deep(.change-color-fill) {
                    fill: var(--secondary-dark-3);
                }
            }
        }

        .content {
            @include H6-Regular;
            line-height: 18px;
            color: var(--secondary-dark-2);
            overflow: hidden;

            &.apply-ellipsis {
                text-overflow: ellipsis;
            }
        }

        &.with-button-icon {
            padding-right: 48px;
        }
    }
}
</style>
